import { connect } from 'react-redux'
import * as selector from '../../state/transition/selector'
import * as action from '../../state/transition/action'
import Transition from './Transition'
import Globals from '../../../globals'


const mapStateToProps = (state, props) => {
    return {
        processStateNameList: Globals.selector.selectProcessStateNameList(state),
        processState: selector.selectProcessState(state),
        yearWeekList: selector.selectYearWeekList(state),
        transitionList: selector.selectTransitionList(state),
        mode: selector.selectMode(state),
    }
}

const mapDispatchToProps = {
    changeProcessState: action.changeProcessState,
    changeYearWeek: action.changeYearWeek,
    deleteYearWeek: action.deleteYearWeek,
}

export default connect(mapStateToProps, mapDispatchToProps)(Transition)



// WEBPACK FOOTER //
// ./src/modules/analytics/component/transition/TransitionContainer.js